import { toCalendarDate, toTime } from "@internationalized/date";
import { InfrastructureForm } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/formSchema";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { RenderErrorInPath } from "shared/components/forms/RenderErrorInPath";
import {
  DateRangePicker,
  Field,
  Grid,
  Stack,
  TimePicker,
} from "shared/components/Spor";
import { AddReserveAlternativeTransportRequest } from "shared/types/alternativeTransport";

type timedDurationsProp = {
  fromTimeField: "infrastructureForm.durations.from_time" | "shiftStartTime";
  toTimeField: "infrastructureForm.durations.to_time" | "shiftEndTime";
};

export const TimedDuration: FC<timedDurationsProp> = ({
  fromTimeField,
  toTimeField,
}) => {
  const {
    setValue,
    watch,
    formState: { errors },
  } = useFormContext<
    InfrastructureForm | AddReserveAlternativeTransportRequest
  >();

  const fromTimeValue = watch(fromTimeField);
  const toTimeValue = watch(toTimeField);

  const { t } = useTranslation();

  return (
    <Stack gap="12px">
      <Field>
        <DateRangePicker
          variant="core"
          startLabel="Startdato"
          endLabel="Sluttdato"
          aria-label="Dato"
          value={{
            start: toCalendarDate(fromTimeValue),
            end: toCalendarDate(toTimeValue),
          }}
          onValueChange={(date) => {
            if (date) {
              setValue(`${fromTimeField}.day`, date.start?.day ?? 0);
              setValue(`${fromTimeField}.month`, date.start?.month ?? 0);
              setValue(`${fromTimeField}.year`, date.start?.year ?? 0);
              setValue(`${toTimeField}.day`, date.end?.day ?? 0);
              setValue(`${toTimeField}.month`, date.end?.month ?? 0);
              setValue(`${toTimeField}.year`, date.end?.year ?? 0);
            }
          }}
        />
      </Field>
      <Grid templateColumns="repeat(2, 1fr)" gap="12px" width="100%">
        <TimePicker
          label={t("Fra kl")}
          width="100%"
          minuteInterval={5}
          value={toTime(fromTimeValue)}
          onValueChange={(time) => {
            if (time !== null) {
              setValue(`${fromTimeField}.hour`, time.hour ?? 0);
              setValue(`${fromTimeField}.minute`, time.minute ?? 0);
            }
          }}
        />
        <TimePicker
          label={t("Til kl")}
          width="100%"
          minuteInterval={5}
          value={toTime(toTimeValue)}
          onValueChange={(time) => {
            if (time !== null) {
              setValue(`${toTimeField}.hour`, time.hour ?? 0);
              setValue(`${toTimeField}.minute`, time.minute ?? 0);
            }
          }}
        />
      </Grid>
      <RenderErrorInPath errors={errors} errorPath={toTimeField} />
    </Stack>
  );
};
